import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarServico from '../../components/modal/ModalCadastrarServico';
import ModalEditarServico from '../../components/modal/ModalEditarServico';
import ModalExcluirServico from '../../components/modal/ModalExcluirServico';
import { ServicoContext } from '../../context/ServicoContext';
import LoadingScreen from '../../components/LoadingScreen';
import Tabela from '../../components/Tabela';

function Servicos() {
    const { Success, Error, openModal, setOpenModal, ServicosConsulta, ListaServicoConsulta, Loading, modalEditarServico, setModalEditarServico, setEdicaoServico, setServicoAtualKey, modalExcluirServico, setModalExcluirServico, InativarServico, ListaFiltroServico, totalRegistrosServico, filtroServico, totalRegistrosFiltroServico } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditServico = (props) => {
        setModalEditarServico(true)
        setServicoAtualKey(props.key)
        setEdicaoServico(props)
    }

    const DeletarServico = (props) => {
        setServicoAtualKey(props.key)
        setModalExcluirServico(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroServico(searchTerm, currentPage, pageSize);
        } else {
            ListaServicoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroServico : totalRegistrosServico;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar serviços'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarServico &&
                <ModalEditarServico currentPage={currentPage} />
            }
            {modalExcluirServico &&
                <ModalExcluirServico />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            {Loading &&
                <LoadingScreen />
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarServico closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "SERVICOS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar serviço</button>
                    }
                </div>
                <div className='card card-table'>
                    <h3 className='h3-demanda' style={h3Demanda}>Serviços cadastrados</h3>
                    <Tabela
                        data={searchTerm.trim() !== "" ? filtroServico : ServicosConsulta}
                        columns={[
                            { label: "Serviço", field: "descricao", width: "20%" },
                            { label: "Grupo", field: "grupo.descricao", width: "20%", render: (x) => x.grupo?.descricao || "-" },
                            { label: "Subgrupo", field: "subGrupo.descricao", width: "20%", render: (x) => x.subGrupo?.descricao || "-" },
                            { label: "Item", field: "item.descricao", width: "20%", render: (x) => x.item?.descricao || "-" },
                             {
                                label: "Ativo",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                        <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarServico(x.key, !x.ativo)} checked={x.ativo} />
                                    </div>
                                ),
                            },
                            {
                                label: "Opções",
                                width: "10%",
                                align: "center",
                                render: (x) => (
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <button onClick={() => EditServico(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                            <TbPencil />
                                        </button>
                                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                            <button onClick={() => DeletarServico(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbTrash />
                                            </button>
                                        }
                                    </div>
                                ),
                            },
                        ]}
                        loading={Loading}
                        currentPage={currentPage}
                        totalPages={totalPages}
                        setCurrentPage={setCurrentPage}
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        onSearch={(term) => {
                            setCurrentPage(1);
                            if (term.trim() !== "") {
                                ListaFiltroServico(term, 1, 10);
                            } else {
                                ListaServicoConsulta(1, 10);
                            }
                        }}
                        corTerciaria={corTerciaria}
                    />
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Servicos;